function initYellowBot() {
  // Prevent duplicate loading
  if (window.yellowBotLoaded) return;
  window.yellowBotLoaded = true;

  // YellowBot configuration
  window.ymConfig = {
    bot: "x1648720333495",
    host: "https://cloud.yellow.ai",
    payload: {
      brand: "anf",
    },
    theme: {
      botName: "Abercrombie & Fitch", //Text upto 50 characters
      botDesc: "Customer Service", //Text upto 50 characters
      primaryColor: "#000000", //RGB or HEX value
      secondaryColor: "#000000", //RGB or HEX value
      botClickIcon: "https://cdn.yellowmessenger.com/JGjb0uErIe4s1759218385043.png", //CDN link
      botIcon: "https://cdn.yellowmessenger.com/JGjb0uErIe4s1759218385043.png"
    }
  };

  // Dynamically load YellowMessenger widget
  (function () {
    var w = window,
      ic = w.YellowMessenger;
    if (typeof ic === "function") {
      ic("reattach_activator");
      ic("update", window.ymConfig);
    } else {
      var d = document,
        i = function () { i.c(arguments); };
      function l() {
        var e = d.createElement("script");
        e.type = "text/javascript";
        e.async = true;
        e.src = "https://cdn.yellowmessenger.com/plugin/widget-v2/latest/dist/main.min.js";
        var t = d.getElementsByTagName("script")[0];
        t.parentNode.insertBefore(e, t);
      }
      i.q = [];
      i.c = function (e) { i.q.push(e); };
      w.YellowMessenger = i;
      w.attachEvent ? w.attachEvent("onload", l) : w.addEventListener("load", l, false);
    }
  })();
}

// Attach to Shopify section load and DOM ready events
document.addEventListener('shopify:section:load', initYellowBot);
document.addEventListener('DOMContentLoaded', initYellowBot);